import rates from "../data/championRoles.json";
import type { Slot } from "./draftPrep";

/** Minimum play rate (%) in a lane for a champion to count as playing it. */
const PLAYRATE_THRESHOLD = 0.5;

const data = rates.data as Record<string, Partial<Record<Slot, { playRate: number }>>>;

/** Whether the champion (numeric Riot key) is played in the lane. Champions missing from the data (brand new) are never filtered out. */
export function playsRole(championId: number, role: Slot): boolean {
	const lanes = data[championId];
	return !lanes || (lanes[role]?.playRate ?? 0) >= PLAYRATE_THRESHOLD;
}
